import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Screen } from '../../components/lease/Screen'
import { BrandHeading } from '../../components/lease/BrandHeading'
import { PrimaryButton } from '../../components/lease/PrimaryButton'

// One-screen landlord onboarding — the ?plan= tier preselection (from the
// marketing site or LandlordAuth) rides through to the pricing link.
export function LandlordOnboarding() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const plan = params.get('plan')

  return (
    <Screen className="text-center">
      <header className="animate-fade-in">
        <BrandHeading className="text-4xl">You're set up</BrandHeading>
        <p className="mt-4 text-slate-600 dark:text-slate-300">
          Upload your lease template — we'll screen it against Colorado law and hand you
          a redline draft to send to an attorney of your choice.
        </p>
      </header>

      <PrimaryButton onClick={() => navigate('/analysis')} className="mt-8 animate-slide-in">
        Review your lease
      </PrimaryButton>

      <button
        onClick={() => navigate(plan ? `/pricing?plan=${plan}` : '/pricing')}
        className="mt-4 w-full text-center text-sm font-semibold text-emerald-700 underline dark:text-emerald-400"
      >
        See pricing
      </button>
    </Screen>
  )
}

export default LandlordOnboarding
